/**
 * @desc 包裹回传
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.OmsFlowPackageChangeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsFlowPackage/savePackage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
